export default {
  name: 'MonthStatistics',
  props: {
    stats: {
      type: Object
    }
  }
}
